$(document).on('turbolinks:load', function() {
  $('.nav--horizontal__hamburger').on('click', function(e) {
    e.preventDefault();

    $('.nav--horizontal__primary').toggleClass('closed');
    $('.nav--horizontal__actions').toggleClass('closed');
  });
});